import { render, staticRenderFns } from "./compareData.vue?vue&type=template&id=303eb8ef&scoped=true&"
import script from "./compareData.vue?vue&type=script&lang=js&"
export * from "./compareData.vue?vue&type=script&lang=js&"
import style0 from "./compareData.vue?vue&type=style&index=0&id=303eb8ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303eb8ef",
  null
  
)

export default component.exports
import {QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable})
